import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { SCRIPTS_SOURCES } from '../../app/util/intune/scripts'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const url = '/secure/policies/intune/deviceManagement-deviceManagementScripts'

const injectSource = (item) => ({ ...item, source: SCRIPTS_SOURCES.DEVICE_MANAGEMENT })

export const intuneDeviceManagementScriptsApi = createApi({
  reducerPath: 'intuneDeviceManagementScripts',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getDeviceManagementScripts: builder.query({
      query: (customerId) => ({
        url,
        params: { customerId },
      }),
      transformResponse: (response) => (Array.isArray(response) ? response.map(injectSource) : response),
    }),
    getDeviceManagementScriptById: builder.query({
      query: ({ customerId, scriptId }) => ({
        url: `${url}/${scriptId}`,
        params: { customerId },
      }),
      transformResponse: (response) => (response ? injectSource(response) : response),
    }),
  }),
})

export const {
  useGetDeviceManagementScriptsQuery,
  useLazyGetDeviceManagementScriptsQuery,
  useGetDeviceManagementScriptByIdQuery,
  useLazyGetDeviceManagementScriptByIdQuery,
} = intuneDeviceManagementScriptsApi

export const useGetDeviceManagementScripts = (options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetDeviceManagementScriptsQuery(customerId, options)
}

export const useGetDeviceManagementScriptById = ({ scriptId }, options) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetDeviceManagementScriptByIdQuery({ customerId, scriptId }, options)
}
